import React from 'react';
var FieldContext = /*#__PURE__*/React.createContext({});
export { FieldContext };
export default FieldContext;